import { about } from './about';
import { barcode } from './barcode';
import { category } from './category';
import { collections } from './collections';
import { countryCode } from './countryCode';
import { description } from './description';
import { files } from './files';
import { hsCode } from './hsCode';
import { materials } from './materials';
import { personalization } from './personalization';
import { photos } from './photos';
import { price } from './price';
import { productType } from './productType';
import { productionPartners } from './productionPartners';
import { quantity } from './quantity';
import { returnPolicy } from './returnPolicy';
import { section } from './section';
import { seo } from './seo';
import { shippingDimensions } from './shippingDimensions';
import { shippingProfile } from './shippingProfile';
import { shippingWeight } from './shippingWeight';
import { sku } from './sku';
import { tags } from './tags';
import { taxonomyAttributes } from './taxonomyAttributes';
import { title } from './title';
import { variations } from './variations';
import { vendor } from './vendor';
import { videos } from './videos';
import { weight } from './weight';
import { getSize } from '../../../iterable/getSize';

import { MENU_ITEM, OPERATIONS } from '../../../../constants/bulkEdit';
import { ETSY, SHOPIFY } from '../../../../constants/channels';
import ATTRIBUTE from '../../../../constants/attributes';

export function applyPreviewOperations({ bulkEdit, userId }) {
  const preview = bulkEdit.get('preview');

  if (getSize(preview) === 0) {
    return {};
  }

  const channel = bulkEdit.get('channel');
  const shopId = bulkEdit.get('shopId');
  const selectedMenuItem = bulkEdit.getIn(['menu', 'selected', 'item']);
  const operation = bulkEdit.getIn(['menu', 'operation']);

  switch (selectedMenuItem) {
    case MENU_ITEM.ABOUT: {
      return about({ preview });
    }

    case MENU_ITEM.BARCODE: {
      return barcode({ channel, operation, preview });
    }

    case MENU_ITEM.BODY_HTML:
    case MENU_ITEM.DESCRIPTION: {
      return description({ channel, operation, preview, state: bulkEdit, userId });
    }

    case MENU_ITEM.CAP:
    case MENU_ITEM.CPI:
    case MENU_ITEM.PRICE: {
      return price({ channel, preview });
    }

    case MENU_ITEM.CATEGORY: {
      return category({ channel, preview });
    }

    case MENU_ITEM.COLLECTIONS: {
      return collections({ channel, preview });
    }

    case MENU_ITEM.COUNTRY_CODE: {
      return countryCode({ preview });
    }

    case MENU_ITEM.FILES: {
      return files({ channel, operation, preview });
    }

    case MENU_ITEM.HS_CODE: {
      return hsCode({ preview });
    }

    case MENU_ITEM.ITEM_SIZE: {
      return shippingDimensions({ channel, operation, preview });
    }

    case MENU_ITEM.ITEM_WEIGHT: {
      return shippingWeight({ operation, preview });
    }

    case MENU_ITEM.MATERIALS: {
      return materials({ channel, preview });
    }

    case MENU_ITEM.PHOTOS: {
      return photos({ channel, operation, preview, state: bulkEdit });
    }

    case MENU_ITEM.VIDEOS: {
      return videos({ channel, operation, preview });
    }

    case MENU_ITEM.PRODUCT_TYPE: {
      return productType({ channel, preview, shopId });
    }

    case MENU_ITEM.PRODUCTION_PARTNER: {
      return productionPartners({ channel, preview });
    }

    case MENU_ITEM.QUANTITY: {
      return quantity({ channel, preview });
    }

    case MENU_ITEM.RETURN_POLICY: {
      return returnPolicy({ preview });
    }

    case MENU_ITEM.SECTION: {
      return section({ channel, preview, shopId });
    }

    case MENU_ITEM.SHIPPING_PROFILE: {
      return shippingProfile({ preview });
    }

    case MENU_ITEM.SKU: {
      return sku({ channel, operation, preview });
    }

    case MENU_ITEM.TAGS: {
      return tags({ channel, operation, preview, state: bulkEdit, userId });
    }

    case MENU_ITEM.TITLE: {
      return title({ channel, operation, preview, state: bulkEdit, userId });
    }

    case MENU_ITEM.VARIATIONS: {
      switch (channel) {
        case ETSY: {
          return preview.has(ATTRIBUTE.VARIATIONS)
            ? variations({ channel, preview })
            : preview.has(ATTRIBUTE.CATEGORY)
              ? category({ channel, preview })
              : {};
        }

        case SHOPIFY: {
          const payload = [];

          if (preview.has(ATTRIBUTE.CATEGORY)) {
            payload.push(category({ channel, preview }).payload);
          }

          if (preview.has(ATTRIBUTE.VARIATIONS)) {
            payload.push(variations({ channel, preview }).payload);
          }

          return { payload };
        }

        default: {
          return {};
        }
      }
    }

    case MENU_ITEM.VENDOR: {
      return vendor({ channel, preview, shopId });
    }

    case MENU_ITEM.WEIGHT: {
      return weight({ preview });
    }

    case MENU_ITEM.PERSONALIZATION: {
      return personalization({ channel, operation, preview });
    }

    case MENU_ITEM.PAGE_TITLE: {
      return seo({
        attribute: ATTRIBUTE.PAGE_TITLE,
        findAndReplaceOperation: OPERATIONS[SHOPIFY].PAGE_TITLE.FIND_AND_REPLACE,
        preview,
      });
    }

    case MENU_ITEM.META_DESCRIPTION: {
      return seo({
        attribute: ATTRIBUTE.META_DESCRIPTION,
        findAndReplaceOperation: OPERATIONS[SHOPIFY].META_DESCRIPTION.FIND_AND_REPLACE,
        preview,
      });
    }

    default: {
      if (bulkEdit.getIn(['menu', 'items', selectedMenuItem, 'isTaxonomy'])) {
        return taxonomyAttributes({ channel, preview, selectedMenuItem });
      }

      return {};
    }
  }
}
